export function smtpSetupForm() {
  const names = [
    "smtpName",
    "smtpHost",
    "smtpPort",
    "smtpEmail",
    "smtpSender",
    "smtpSenderEmail",
    "smtpPassword"
  ];

  return names;
}
